import { lt, showSuccessAlert } from '@mews/framework';
import { CommanderThunkAction } from '@mews-commander/types';
import { getDateTimeUtc } from '@mews-commander/utils';
import { updateTask, addTask } from '@mews-commander/legacy-entities/src/actions/tasks';
import { getCurrentEnterpriseIanaTimeZoneIdentifier } from '@mews-commander/legacy-entities/src/selectors/session/enterprise';
import { getCurrentDateTimeLocalizationInfo } from '@mews-commander/core/legacy-globalization';
import { openModal, navigateInModal } from '../../app/actions/common';
import { getTaskCreateUrl, getTaskDetailUrl } from './routing';

export const updateTaskData =
    (task: $TSFixMe, taskId: $TSFixMe): CommanderThunkAction =>
    (dispatch, getState) => {
        const { date, time, ...other } = task;
        const timezone = getCurrentEnterpriseIanaTimeZoneIdentifier(getState());
        const localizationInfo = getCurrentDateTimeLocalizationInfo(getState());
        const deadlineUtc = getDateTimeUtc({ timezone, localizationInfo, date, time });

        return dispatch(updateTask({ taskId, deadlineUtc, ...other })).then(() =>
            showSuccessAlert({ description: lt('SaveSuccessMessage') })
        );
    };

export const createTask =
    (formData: $TSFixMe, imageIds: string[] | null): CommanderThunkAction =>
    async (dispatch, getState) => {
        const { date, time, ...other } = formData;
        const timezone = getCurrentEnterpriseIanaTimeZoneIdentifier(getState());
        const localizationInfo = getCurrentDateTimeLocalizationInfo(getState());
        const deadlineUtc = getDateTimeUtc({ timezone, localizationInfo, date, time });

        return dispatch(addTask({ deadlineUtc, imageIds, ...other })).then(({ value: { id } }) => {
            showSuccessAlert({ description: lt('SaveSuccessMessage') });
            dispatch(navigateToTaskDetailModal(id));
        });
    };

export const openTaskCreationModal =
    ({ serviceOrderId }: $TSFixMe): CommanderThunkAction =>
    (dispatch, getState, { resolveRoute }) => {
        const url = getTaskCreateUrl(resolveRoute)(serviceOrderId);
        dispatch(openModal(url));
    };

export const navigateToTaskDetailModal =
    (id: $TSFixMe): CommanderThunkAction =>
    (dispatch, getState, { resolveRoute }) => {
        const url = getTaskDetailUrl(resolveRoute)(id);
        dispatch(navigateInModal(url));
    };
